export default __webpack_public_path__ + "static/media/pdf.db816292.png";